function closeNavbar() {
    $('.navbar-toggler').removeClass('is-active');
    $('.navbar-collapse').removeClass('is-opened')
    $('.page-content, .navbar--top').removeClass('navbar-opened')
}

(function($) {
    $(() => {

        // SHOW HIDDEN ELEMENTS
        //
        $('.js-shown-after-loading').addClass('is-loaded');

        // MODAL EVENTS
        //
        $('#loginModal').on('show.bs.modal', function () {
            closeNavbar();
            if(!$('#login input[name="email"]').parents('.form-group').hasClass('has-error')) {
                setTimeout(function(){
                    $('#login input[name="email"]').focus();
                },500);
            }
        });

        $('.js-show-dropdown').click(function(){
            $('.dropdown').removeClass('is-shown');
            $('.dropdown',this).addClass('is-shown');
        });


        // CLICK SOMEWHERE ELSE
        $(document).mouseup(function(e) {
            var container = $('.js-show-dropdown');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.dropdown').removeClass('is-shown');
            }
        });

        $('.js-logout').click(function() {
            $('#logout-form-navbar').trigger('submit');
        });

        // ERROR AFTER TRYING TO LOGIN
        //
        if(($('.active#login-tab').length > 0) && $('form#login .has-error').length > 0) {
            $('.modal #reg .form-group.has-error').removeClass('has-error');
            $('#loginModal').modal('show');
            $('.nav-tabs a[href="#login"]').tab('show');
            $('form#reg input[type="email"]').val('');
            $('form#reg input[type="text"]').val('');
            $('form#reg input[type="password"]').val('');
            updateForms();
        }

        // ERROR AFTER TRYING TO REGISTER
        //
        if(($('.active#reg-tab').length > 0) && $('form#reg .has-error').length > 0) {
            $('.modal #login .form-group.has-error').removeClass('has-error');
            $('#loginModal').modal('show');
            $('.nav-tabs a[href="#reg"]').tab('show');
            $('form#login input[type="email"]').val('');
            $('form#login input[type="text"]').val('');
            $('form#login input[type="password"]').val('');
            updateForms();
        }

        $('.js-show-reg-tab').click(function(){
            $('.nav-tabs a[href="#reg"]').tab('show');
        });

    });
})(jQuery);
